import clsx from 'clsx'
import { motion, type Variants } from 'framer-motion'
import { AnimatePresence } from 'framer-motion'
import { type ComponentProps } from 'react'
import { Text } from 'ui/src/components/Text/Text'
import { framerTransitions } from 'ui/src/theme/transitions'
import { useFormatter } from '@/utils/useFormatter'
import { useSelectedOffer } from '../../PurchaseFormV2/useSelectedOffer'
import { priceLabel, priceWrapper } from './SelectedOfferAnimatedPrice.css'

const TRAVEL_DISTANCE = '1em'
const ANIMATION: Variants = {
  pushDown: { y: TRAVEL_DISTANCE, opacity: 0 },
  original: { y: 0, opacity: 1 },
  pushUp: { y: `-${TRAVEL_DISTANCE}`, opacity: 0 },
}
const TRANSITION = { duration: 0.3, ...framerTransitions.easeInOutCubic }

type Props = ComponentProps<'div'> & {
  color?: ComponentProps<typeof Text>['color']
}

export function SelectedOfferAnimatedPrice({ color, className, ...props }: Props) {
  const formatter = useFormatter()
  const [selectedOffer] = useSelectedOffer()

  if (!selectedOffer) {
    return null
  }

  return (
    <div className={clsx(priceWrapper, className)} {...props}>
      <AnimatePresence initial={false}>
        <motion.div
          key={selectedOffer.id}
          className={priceLabel}
          transition={TRANSITION}
          variants={ANIMATION}
          initial="pushDown"
          animate="original"
          exit="pushUp"
        >
          <Text color={color}>{formatter.monthlyPrice(selectedOffer.cost.net)}</Text>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
